<template>
  <div class="Unauthorized">Unauthorized</div>
</template>

<script>
export default {
  name: 'Unauthorized',

  data() {
    return {};
  },
};
</script>
